import { Provider } from 'react-redux';
import { Route, BrowserRouter as Router } from 'react-router-dom';

import DynamicRegistration from './Containers/DynamicRegistrationWrapper';
import rootReducer from './duck';

import { apiMiddleware } from '$ReduxLegacy/Middleware/API';
import { apiAsyncMiddleware } from '$ReduxLegacy/Middleware/APIAsync';
import configureStore from '$ReduxLegacy/Stores/configureStore';

const store = configureStore(rootReducer, {
    thunk: true,
    middleware: [apiMiddleware, apiAsyncMiddleware]
});

const App = () => {
    return (
        <Provider store={store}>
            <Router basename="/registration/d">
                <Route component={DynamicRegistration} />
            </Router>
        </Provider>
    );
};

export default App;
